@if (!simple) {
  @if (!menuItemMode && !loading) {
    <button mat-raised-button color="primary" (click)="onClick(actionConfig)" [disabled]="isDisabled">
      {{ actionConfig.buttonLabel }}
    </button>
  }
  @if (!menuItemMode && loading) {
    <button mat-raised-button color="primary" disabled>
      <mat-spinner class="spinner" [diameter]="20"></mat-spinner>
    </button>
  }
  @if (menuItemMode && !loading && !isDisabled) {
    @if (!actionConfig.children || actionConfig.children.length === 0) {
      <button
        mat-menu-item
        color="primary"
        [attr.data-id]="'option_' + actionConfig.buttonLabel"
        (click)="onClick(actionConfig)">
        @if (hasWarning) {
          <mat-icon [matTooltip]="actionConfig.warningMessage">warning</mat-icon>
        }
        <span>{{ actionConfig.buttonLabel }}</span>
      </button>
    }
    @if (actionConfig.children && actionConfig.children.length > 0 && anyChildrenAvailable) {
      <button [matMenuTriggerFor]="nested" mat-menu-item color="primary">
        @if (hasWarning) {
          <mat-icon [matTooltip]="actionConfig.warningMessage">warning</mat-icon>
        }
        <span>{{ actionConfig.parentMenuLabel }}</span>
      </button>
    }
  }
  <mat-menu #nested="matMenu">
    @if (anyChildrenAvailable) {
      @for (action of actionConfig.children; track action) {
        <button
          [hidden]="isDisabledChildren[action.buttonLabel]"
          mat-menu-item
          color="primary"
          (click)="onClick(action)">
          @if (isChildWithWarning[action.buttonLabel]) {
            <mat-icon [matTooltip]="action.warningMessage">warning</mat-icon>
          }
          <span>{{ action.buttonLabel }}</span>
        </button>
      }
    }
  </mat-menu>
}
@if (simple) {
  <span
    [attr.data-id]="'action_' + actionConfig.buttonLabel"
    class="simple-action-label"
    (click)="onClick(actionConfig)"
    >{{ actionConfig.buttonLabel }}</span
  >
}
